import React, { useEffect, useState } from "react";
import { toggleSidebar, toggleTheme } from "../ui.js";
import { Github, Bell, Moon, Sun, Search } from "lucide-react";
import IconButton from "@mui/material/IconButton";
import { LoginOutlined } from "@mui/icons-material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

const API_URL = "/api/sign-out";

export default function Header() {
  const [collapsed, setCollapsed] = useState(false);
  const [theme, setTheme] = useState("light");

  const handleSignOut = async () => {
    window.location.href = API_URL;
  };

  useEffect(() => {
    setCollapsed(document.body.classList.contains("sidebar-collapsed"));
    setTheme(document.documentElement.classList.contains("theme-dark") ? "dark" : "light");

    const onSidebar = (e) => setCollapsed(!!e.detail?.collapsed);
    const onTheme = (e) => setTheme(e.detail?.theme || "light");

    window.addEventListener("ui:sidebar", onSidebar);
    window.addEventListener("ui:theme", onTheme);

    return () => {
      window.removeEventListener("ui:sidebar", onSidebar);
      window.removeEventListener("ui:theme", onTheme);
    };
  }, []);

  const isDark = theme === "dark";

  return (
    <header className="app-header">
      <IconButton
        onClick={() => toggleSidebar()}
        aria-label="Toggle menu"
        aria-expanded={!collapsed}
        disableRipple
        className="menu-toggle"
        sx={{
          padding: 0,
          minWidth: 0,
          borderRadius: 0,
          color: "inherit",
          "&:hover": { backgroundColor: "transparent" },
        }}
      >
        {collapsed ? <MenuIcon sx={{ fontSize: 24 }} /> : <CloseIcon sx={{ fontSize: 24 }} />}
      </IconButton>

      <div className="brand">
        <img className="brand-logo" src="/assets/img/cgi-logo.svg" alt="CGI" loading="eager" />
        <span className="brand-divider" aria-hidden="true"></span>
        <span className="brand-text">ITS Jump-Start</span>
      </div>

      <div className="header-right">
        <div className="search-container">
          <div className="search-wrapper">
            <Search className="search-icon" size={20} />
            <input className="search" type="search" placeholder="Search" />
          </div>
        </div>

        <button className="icon-btn" aria-label="GitHub" title="GitHub (stub)" type="button">
          <Github size={20} />
        </button>
        <button className="icon-btn" aria-label="Alerts" title="Alerts (stub)" type="button">
          <Bell size={20} />
        </button>

        <button
          className="icon-btn"
          aria-label="Theme"
          title={isDark ? "Switch to light" : "Switch to dark"}
          onClick={() => toggleTheme()}
          type="button"
        >
          {isDark ? <Sun size={20} /> : <Moon size={20} />}
        </button>
        <a className="icon-btn" title="Sign Out" aria-label="Sign Out" href={API_URL}>
          <LoginOutlined fontSize="small" />
        </a>
      </div>
    </header>
  );
}
